import {
  AlternativeProductCardProps,
  ProductCard
} from '@coolblue-development/next-patterns/client';
import styled from '@emotion/styled';

export const StyledHighlightedAlternativeProductCard = styled(
  ProductCard.Alternative
)<AlternativeProductCardProps>(({ theme }) => ({
  display: 'contents',

  label: {
    '& p': {
      gridRow: '1'
    },

    gap: '0',
    gridTemplateRows: 'subgrid',
    gridColumn: 'span 12',
    gridRow: 'span 3',
    [theme.breakpoint.minWidth('md')]: {
      gridColumn: 'span 4'
    }
  }
}));

export const StyledAlternativeProductCard = styled(
  ProductCard.Alternative
)<AlternativeProductCardProps>(({ theme }) => ({
  display: 'contents',

  label: {
    '& p': {
      gridRow: '1'
    },

    gap: '0',
    gridTemplateRows: 'subgrid',
    gridColumn: 'span 12',
    gridRow: 'span 2',
    [theme.breakpoint.minWidth('md')]: {
      gridColumn: 'span 4'
    }
  }
}));

// Needed to override the display property of the tracking component
export const StyledTrackingContainer = styled.div`
  display: contents;

  > div {
    display: contents;
  }
`;
